<template>
  <button @click="$emit('click')" class="btn btn-info btn-block">
    <i class="fa fa-binoculars"></i> Lọc Dữ Liệu
  </button>
</template>

<script>
export default {
  name: "find-button"
};
</script>
